import { axiosInstance } from "../../config/axios";
import { AxiosError } from "axios";
import { useMutation } from "react-query";

export type CreateGMUCustomerRequest = {
  merchantId: number;
  preValidate: boolean;
};

async function createGMUCustomer(data: CreateGMUCustomerRequest): Promise<any> {
  try {
    return (
      await axiosInstance.post(
        `/Merchant/CreateCustomer?merchantId=${data.merchantId}&preValidate=${data.preValidate}`
      )
    ).data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}

export function useCreateGMUCustomer() {
  return useMutation<any, Error, CreateGMUCustomerRequest>(
    (variables) => createGMUCustomer(variables)
  );
}
